export default __webpack_public_path__ + "static/media/295.386b3135.png";